import { ofType } from 'redux-observable';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
    fetchWithdrawalBalanceV2 as fetchWithdrawalBalanceV2Action,
    fetchWithdrawalBalanceV2Error,
    fetchWithdrawalBalanceV2Success,
} from '@perpay-web/fintech/actions/entities/withdrawalBalance';
import {
    createWithdrawalRequest as createWithdrawalRequestAction,
    createWithdrawalRequestErrors,
    createWithdrawalRequestSuccess,
    fetchWithdrawalBalance as fetchWithdrawalBalanceAction,
    replaceWithdrawalBalance,
    withdrawalBalanceError,
} from '@perpay-web/fintech/actions/ui/withdrawal';
import {
    WITHDRAWAL_BALANCE_ENDPOINT,
    WITHDRAWAL_REQUEST_ENDPOINT,
} from '@perpay-web/fintech/constants/urls';
import { handleErrorMessageWithFallback } from '@perpay-web/observable/operators/handleErrorMessageWithFallback';
import { emitOrTimeout } from '@perpay-web/utils/observable';

const fetchWithdrawalBalance = (action$, state$, { get }) =>
    action$.pipe(
        ofType(fetchWithdrawalBalanceAction().type),
        switchMap(() => emitOrTimeout(get(WITHDRAWAL_BALANCE_ENDPOINT))),
        mergeMap((results) => [replaceWithdrawalBalance(results.response)]),
        handleErrorMessageWithFallback((error) => [
            withdrawalBalanceError(error),
        ]),
    );

const fetchWithdrawalBalanceV2 = (action$, state$, { get }) =>
    action$.pipe(
        ofType(fetchWithdrawalBalanceV2Action().type),
        switchMap(() => emitOrTimeout(get(WITHDRAWAL_BALANCE_ENDPOINT))),
        mergeMap((results) => [
            fetchWithdrawalBalanceV2Success(results.response),
        ]),
        handleErrorMessageWithFallback((error) => [
            fetchWithdrawalBalanceV2Error(error),
        ]),
    );

const createWithdrawalRequest = (action$, state$, { post }) =>
    action$.pipe(
        ofType(createWithdrawalRequestAction().type),
        switchMap((action) => {
            const {
                payload: { withdrawalAccount: accountUuid, amount },
            } = action;
            const requestBody = {
                to_account_uuid: accountUuid,
                amount,
            };
            return emitOrTimeout(
                post(WITHDRAWAL_REQUEST_ENDPOINT, requestBody),
            );
        }),

        mergeMap((results) => [createWithdrawalRequestSuccess(results)]),
        handleErrorMessageWithFallback((error) => [
            createWithdrawalRequestErrors(error),
        ]),
    );

export {
    createWithdrawalRequest,
    fetchWithdrawalBalance,
    fetchWithdrawalBalanceV2,
};
